import {
  GET_CITIES_LOADING,
  GET_CITIES_SUCCESS,
  GET_CITIES_FAILURE,
} from "redux/types";

const initialState ={
    citiesLoading: false ,
    cities: null ,
    errors:null 
}


export const getCitiesReducer =(state= initialState, action:any) => {
    switch (action.type) {
        case GET_CITIES_LOADING: 
        return {...state, citiesLoading: action.payload}
        case GET_CITIES_SUCCESS: 
        return {...state, cities: action.payload}
        case GET_CITIES_FAILURE:
            return {...state, errors:action.payload}
            default: 
            return state
    }
}